//     // import { useEffect, useState } from 'react';
//     // import { api } from '../api/client';

//     // export default function WebhookSection({ appId }) {
//     // const [webhooks, setWebhooks] = useState([]);
//     // const [eventTypes, setEventTypes] = useState([]);
//     // const [form, setForm] = useState({
//     //     event_type: '',
//     //     target_url: '',
//     //     secret: '',
//     //     is_active: true
//     // });

//     // const fetchWebhooks = async () => {
//     //     try {
//     //     const res = await api.get(`/apps/${appId}/webhooks`);
//     //     setWebhooks(res.data);
//     //     } catch (err) {
//     //     console.error('Failed to load webhooks');
//     //     }
//     // };

//     // const fetchEventTypes = async () => {
//     //     try {
//     //     const res = await api.get(`/event-types`);
//     //     setEventTypes(res.data || []);
//     //     // Set default selected type if none
//     //     if (res.data && res.data.length > 0) {
//     //         setForm((prev) => ({ ...prev, event_type: res.data[0] }));
//     //     }
//     //     } catch (err) {
//     //     console.error('Failed to load event types');
//     //     }
//     // };

//     // const handleAdd = async () => {
//     //     try {
//     //     await api.post(`/apps/${appId}/webhooks`, form);
//     //     setForm({
//     //         event_type: eventTypes[0] || '',
//     //         target_url: '',
//     //         secret: '',
//     //         is_active: true
//     //     });
//     //     fetchWebhooks();
//     //     } catch (err) {
//     //     alert('Failed to create webhook');
//     //     }
//     // };

//     // const handleDelete = async (id) => {
//     //     const confirmDelete = window.confirm("Are you sure you want to delete this webhook?");
//     //     if (!confirmDelete) return;
//     //     await api.delete(`/webhooks/${id}`);
//     //     fetchWebhooks();
//     // };

//     // useEffect(() => {
//     //     if (appId) {
//     //     fetchWebhooks();
//     //     fetchEventTypes();
//     //     }
//     // }, [appId]);

//     // return (
//     //     <div className="bg-white p-4 rounded shadow">
//     //     <h3 className="text-lg font-bold mb-4">Webhooks</h3>

//     //     {/* Form */}
//     //     <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//     //         <select
//     //         name="event_type"
//     //         value={form.event_type}
//     //         onChange={(e) => setForm({ ...form, event_type: e.target.value })}
//     //         className="border px-3 py-2 rounded"
//     //         >
//     //         {eventTypes.map(e => (
//     //             <option key={e} value={e}>{e}</option>
//     //         ))}
//     //         </select>
//     //         <input
//     //         type="text"
//     //         placeholder="Target URL"
//     //         className="border px-3 py-2 rounded"
//     //         value={form.target_url}
//     //         onChange={e => setForm({ ...form, target_url: e.target.value })}
//     //         />
//     //         <input
//     //         type="text"
//     //         placeholder="Secret (optional)"
//     //         className="border px-3 py-2 rounded"
//     //         value={form.secret}
//     //         onChange={e => setForm({ ...form, secret: e.target.value })}
//     //         />
//     //         <div>
//     //         <label className="inline-flex items-center mt-2">
//     //             <input
//     //             type="checkbox"
//     //             className="form-checkbox"
//     //             checked={form.is_active}
//     //             onChange={e => setForm({ ...form, is_active: e.target.checked })}
//     //             />
//     //             <span className="ml-2">Enabled</span>
//     //         </label>
//     //         </div>
//     //         <button
//     //         onClick={handleAdd}
//     //         className="col-span-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
//     //         >
//     //         Add Webhook
//     //         </button>
//     //     </div>

//     //     {/* Webhook List */}
//     //     <table className="w-full text-sm border">
//     //         <thead className="bg-gray-100 text-left">
//     //         <tr>
//     //             <th className="p-2">Event</th>
//     //             <th className="p-2">URL</th>
//     //             <th className="p-2">Status</th>
//     //             <th className="p-2">Actions</th>
//     //         </tr>
//     //         </thead>
//     //         <tbody>
//     //         {webhooks.map((w) => (
//     //             <tr key={w.id} className="border-t">
//     //             <td className="p-2">{w.event_type}</td>
//     //             <td className="p-2 text-blue-600 underline">
//     //                 <a href={w.target_url} target="_blank" rel="noreferrer">{w.target_url}</a>
//     //             </td>
//     //             <td className="p-2">{w.is_active ? '✅ Active' : '❌ Disabled'}</td>
//     //             <td className="p-2 text-right">
//     //                 <button onClick={() => handleDelete(w.id)} className="text-red-600 hover:underline">Delete</button>
//     //             </td>
//     //             </tr>
//     //         ))}
//     //         </tbody>
//     //     </table>
//     //     </div>
//     // );
//     // }


// import DeveloperLayout from '../../layouts/DeveloperLayout';
// import WebhookSection from '../../components/widgets/WebhookSection';

// export default function Webhooks() {
//   // For now we keep this page empty since the webhook config happens inside app-specific page
//   return (
//     <DeveloperLayout>
//       <div className="space-y-6">
//         <h2 className="text-2xl font-bold mb-4">Webhooks</h2>
//         <p className="text-gray-600">
//           Manage your webhooks directly within each individual app. Select an app from "My Apps" to configure.
//         </p>
//       </div>
//     </DeveloperLayout>
//   );
// }

export default function Webhooks() {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Webhooks</h1>
      <div className="bg-white p-6 rounded-lg shadow">
        <p className="text-gray-600">
          Configure webhooks directly within each app. Go to "My Apps" and click "Configure Webhooks" on any app.
        </p>
      </div>
    </div>
  );
}